import { FC, SVGProps } from 'react'

export const IconFileDigit: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#0062CA"
    {...props}
  >
    <path
      d="M7.66675 42.1667H34.5001C35.5167 42.1667 36.4918 41.7628 37.2107 41.0439C37.9295 40.3251 38.3334 39.35 38.3334 38.3334V14.375L27.7917 3.83337H11.5001C10.4834 3.83337 9.50839 4.23724 8.78951 4.95613C8.07062 5.67502 7.66675 6.65004 7.66675 7.66671V15.3334"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.8333 3.83337V15.3334H38.3333"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1667 23H23.0001V34.5"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4999 23H3.83325V34.5H11.4999V23Z"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1667 34.5H26.8334"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
